// Node-like globals for browser bundles (CRA / webpack)
import { Buffer } from 'buffer'
import process from 'process/browser'
import util from 'util'
import assert from 'assert'

;(globalThis as any).Buffer = (globalThis as any).Buffer || Buffer
;(window as any).Buffer = (window as any).Buffer || Buffer
;(global as any).Buffer = (global as any).Buffer || Buffer

;(globalThis as any).process = (globalThis as any).process || process
;(window as any).process = (window as any).process || process
;(global as any).process = (global as any).process || process

;(globalThis as any).util = (globalThis as any).util || util
;(window as any).util = (window as any).util || util
;(global as any).util = (global as any).util || util

;(globalThis as any).assert = (globalThis as any).assert || assert
;(window as any).assert = (window as any).assert || assert
;(global as any).assert = (global as any).assert || assert

;(globalThis as any).global = (globalThis as any).global || globalThis
